import { BrowseCategorySlug } from '@engage/browse-categories';
import * as Icons from './icons';
import { Free } from './icons/Free';

export const toBrowseCategoryIcon = (slug: BrowseCategorySlug) => {
  switch (slug) {
    case BrowseCategorySlug.Cardio:
      return Icons.Cardio;
    case BrowseCategorySlug.Cycling:
      return Icons.Cycling;
    case BrowseCategorySlug.Strength:
      return Icons.Strength;
    case BrowseCategorySlug.Stretching:
      return Icons.Stretching;
    case BrowseCategorySlug.TotalBody:
      return Icons.TotalBody;
    case BrowseCategorySlug.Running:
      return Icons.Running;
    case BrowseCategorySlug.Yoga:
      return Icons.Yoga;
    case BrowseCategorySlug.Walking:
      return Icons.Walking;
    case BrowseCategorySlug.Outdoor:
      return Icons.Outdoor;
    case BrowseCategorySlug.Bootcamp:
      return Icons.Bootcamp;
    case BrowseCategorySlug.Meditation:
      return Icons.Meditation;
    case BrowseCategorySlug.BikeBootcamp:
      return Icons.BikeBootcamp;
    case BrowseCategorySlug.Caesar:
      return Icons.Caesar;
    case BrowseCategorySlug.CaesarBootcamp:
      return Icons.CaesarBootcamp;
    case BrowseCategorySlug.All:
      return Icons.All;
    case BrowseCategorySlug.Free:
      return Free;
    default:
      return Icons.TotalBody;
  }
};
